import { lazy } from 'react';

export const RewardPlayerAssignForm = lazy(
  () => import('./RewardPlayerAssignForm'),
);
